export default __webpack_public_path__ + "static/media/mario_coin.4876b916.mp3";